module.exports = __webpack_public_path__ + "static/media/bg-breacrum.1a7cc718.jpg";